<template>
    <div :id="modalName">
        <b-modal :id="modalName" hide-footer size="lg">
            <template v-slot:modal-title>
                Export Line Items
            </template>



            <!-- <b-button type="submit" variant="success" @click="exportColumns">
                <span v-if="submitting">
                    <b-spinner small type="grow"></b-spinner>
                    Exporting...
                </span>
                <span v-else>Export</span>
            </b-button> -->
        </b-modal>
    </div>
</template>

<script>
export default {
    props: [
        'fields',
        'ignores'
    ],

    components: {

    },

    data() {
        return {
            modalName: 'modal-common-export-line-items',
            submitting: 0
        }
    },

    methods: {
        // exportColumns() {
        //     let cols = []
        //     let keys = []
        //     this.fields.forEach(key => {
        //         if (key.visible && !this.ignores.includes(key.key)) {
        //             cols.push(key.label)
        //             keys.push(key.key)
        //         }
        //     })

        //     this.closeModal(this.modalName)
        //     this.$emit('exportExcel', cols, keys)
        // }
    },

    computed: {

    },

    mounted() {
        // this.updatedFields = Object.assign({}, this.fields)
    }
}
</script>
<style lang="scss">
#modal-common-export-line-items {
    // .modal-dialog {
    //     width: 250px;
    // }
}
</style>
